/**
 * @generated SignedSource<<6c133b5c159dde68496e365a0ea1c54a>>
 * @relayHash 481d392bd2923af8f1d434eeaa694933
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/545.0.0-2026-02-05T14:54:35.766Z/sbRespCreatorsRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageDisplayEnum = "auctionsSearchAndBrowse" | "cart" | "catalog" | "checkout" | "email" | "favorites" | "homepage" | "mc" | "pdp" | "publication" | "searchAndBrowse" | "similarSold" | "visuallySimilar" | "%future added value";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type sbRespCreatorsRootQuery$variables = {
  contentModuleId?: string | null;
  disableForceFacet?: boolean | null;
  disableNonParameterizedUrlRedirects?: boolean | null;
  fetchRegionalInfo?: boolean | null;
  fetchUser: boolean;
  first?: number | null;
  followSearchPages?: ReadonlyArray<string | null> | null;
  followSearchTypes?: ReadonlyArray<types | null> | null;
  guestId?: string | null;
  isClient?: boolean | null;
  isTrade: boolean;
  localeOrigin?: string | null;
  originalUrl?: string | null;
  page?: number | null;
  pageDisplayEnum?: PageDisplayEnum | null;
  personalizationId?: string | null;
  priceBookName?: string | null;
  regions?: string | null;
  regionsList?: ReadonlyArray<string | null> | null;
  relatedBuyPagesCount?: number | null;
  rerankGuestId?: string | null;
  rerankUserId?: string | null;
  showSeller: boolean;
  uriRef?: string | null;
  userCountryCode?: string | null;
  userId?: string | null;
  userZipCode?: string | null;
};
export type sbRespCreatorsRootQuery$data = {
  readonly viewer: {
    readonly creatorRootPage: {
      readonly redirectLocation: string | null;
      readonly verticalItems: ReadonlyArray<{
        readonly list: ReadonlyArray<{
          readonly item: {
            readonly title: string | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorsLayout_viewer">;
  };
};
export type sbRespCreatorsRootQuery = {
  response: sbRespCreatorsRootQuery$data;
  variables: sbRespCreatorsRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentModuleId"
},
v1 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "disableForceFacet"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "disableNonParameterizedUrlRedirects"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followSearchPages"
},
v7 = {
  "defaultValue": [
    "SEARCH",
    "USER_PREFERENCE"
  ],
  "kind": "LocalArgument",
  "name": "followSearchTypes"
},
v8 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "guestId"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isClient"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v11 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "localeOrigin"
},
v12 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "originalUrl"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v14 = {
  "defaultValue": "searchAndBrowse",
  "kind": "LocalArgument",
  "name": "pageDisplayEnum"
},
v15 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "personalizationId"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regions"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regionsList"
},
v19 = {
  "defaultValue": 6,
  "kind": "LocalArgument",
  "name": "relatedBuyPagesCount"
},
v20 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "rerankGuestId"
},
v21 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "rerankUserId"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showSeller"
},
v23 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "uriRef"
},
v24 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v25 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v26 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v27 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v28 = [
  (v27/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redirectLocation",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v31 = [
  (v30/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creationDate",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "period",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v39 = [
  (v36/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v42 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v43 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v44 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    },
    (v45/*: any*/)
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountType",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regionName",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v52 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  (v51/*: any*/)
],
v53 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v55 = [
  (v54/*: any*/),
  (v41/*: any*/)
],
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v37/*: any*/)
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v59 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    (v54/*: any*/),
    (v56/*: any*/)
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "style",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallPath",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webPath",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v66 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerProfile",
  "kind": "LinkedField",
  "name": "sellerProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "company",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v69 = {
  "alias": "isRewarded",
  "args": [
    {
      "kind": "Literal",
      "name": "listNames",
      "value": [
        "SELLER_REWARDS_1",
        "SELLER_REWARDS_2"
      ]
    }
  ],
  "kind": "ScalarField",
  "name": "isAnchorListsMember",
  "storageKey": "isAnchorListsMember(listNames:[\"SELLER_REWARDS_1\",\"SELLER_REWARDS_2\"])"
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchTerm",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eyeBrowText",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mainImage",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "LocalizedLinkData",
  "kind": "LinkedField",
  "name": "localizedLinkDataList",
  "plural": true,
  "selections": [
    (v45/*: any*/),
    (v56/*: any*/)
  ],
  "storageKey": null
},
v78 = [
  (v71/*: any*/)
],
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photo",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtitle",
  "storageKey": null
},
v81 = [
  (v54/*: any*/)
],
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorText",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v84 = [
  {
    "kind": "Variable",
    "name": "countryCode",
    "variableName": "userCountryCode"
  },
  {
    "kind": "Variable",
    "name": "zipCode",
    "variableName": "userZipCode"
  }
],
v85 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RegionsByZipCode",
    "kind": "LinkedField",
    "name": "regionsByZipCode",
    "plural": true,
    "selections": (v81/*: any*/),
    "storageKey": null
  },
  (v41/*: any*/)
],
v86 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "followSearchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "followSearchTypes"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "sbRespCreatorsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SbRespCreatorsLayout_viewer"
          },
          {
            "alias": null,
            "args": (v28/*: any*/),
            "concreteType": "CreatorRootPage",
            "kind": "LinkedField",
            "name": "creatorRootPage",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VerticalItems",
                "kind": "LinkedField",
                "name": "verticalItems",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchResult",
                    "kind": "LinkedField",
                    "name": "list",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "item",
                        "plural": false,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v25/*: any*/),
      (v15/*: any*/),
      (v8/*: any*/),
      (v21/*: any*/),
      (v20/*: any*/),
      (v4/*: any*/),
      (v23/*: any*/),
      (v12/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v9/*: any*/),
      (v22/*: any*/),
      (v26/*: any*/),
      (v24/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v13/*: any*/),
      (v17/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v19/*: any*/),
      (v14/*: any*/),
      (v16/*: any*/),
      (v18/*: any*/)
    ],
    "kind": "Operation",
    "name": "sbRespCreatorsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "isWordpressArticlesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "WP_EDITORIAL"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
          },
          {
            "alias": "isRelatedCreatorsModuleEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "relatedCreatorsModule"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"relatedCreatorsModule\")"
          },
          {
            "alias": "isRelatedBuyPagesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "RELATED_BUY_PAGES"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"RELATED_BUY_PAGES\")"
          },
          {
            "alias": "video",
            "args": null,
            "concreteType": "VideoVimeo",
            "kind": "LinkedField",
            "name": "itemVideo",
            "plural": false,
            "selections": [
              {
                "alias": "videoThumb",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "pad",
                    "value": false
                  },
                  {
                    "kind": "Literal",
                    "name": "size",
                    "value": "w295h166"
                  }
                ],
                "kind": "ScalarField",
                "name": "thumbnail",
                "storageKey": "thumbnail(pad:false,size:\"w295h166\")"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              },
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VideoVimeoFile",
                "kind": "LinkedField",
                "name": "fileByVideoSize",
                "plural": false,
                "selections": [
                  (v33/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "isPopularSearchesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "popularSearches"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"popularSearches\")"
          },
          {
            "alias": "showCreatorDesignTiles",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "sbCreatorDesignTiles"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"sbCreatorDesignTiles\")"
          },
          {
            "alias": null,
            "args": (v28/*: any*/),
            "concreteType": "CreatorRootPage",
            "kind": "LinkedField",
            "name": "creatorRootPage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "verticals",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CreatorRootTransactions",
                "kind": "LinkedField",
                "name": "CreatorRootTransactions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "averageSoldPrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minPrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxPrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecentSalesTransaction",
                    "kind": "LinkedField",
                    "name": "recentSales",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "soldDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "soldPrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "categories",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "medium",
                        "storageKey": null
                      },
                      (v34/*: any*/),
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CreatorRootAttributes",
                "kind": "LinkedField",
                "name": "creatorRootAttributes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "topPrimaryL1Style",
                    "plural": true,
                    "selections": (v39/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "topPrimaryL1Material",
                    "plural": true,
                    "selections": (v39/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "verticalsUriRef",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VerticalItems",
                "kind": "LinkedField",
                "name": "verticalItems",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchResult",
                    "kind": "LinkedField",
                    "name": "list",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "item",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ecommerceTrackingParams",
                            "storageKey": null
                          },
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              (v40/*: any*/),
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "displayPriceTracking",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "catchNonFatalErrors",
                                "value": false
                              },
                              (v42/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "page",
                                "variableName": "pageDisplayEnum"
                              },
                              (v43/*: any*/),
                              (v44/*: any*/)
                            ],
                            "concreteType": "ItemDisplayPriceType",
                            "kind": "LinkedField",
                            "name": "displayPrice",
                            "plural": true,
                            "selections": [
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v48/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "address",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "englishCountryName",
                                "storageKey": null
                              },
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayCountry",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "medianL3SoldItemPriceScore",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "categoryCode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "browseUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contemporaryTrackingString",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isNewListing",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "personalizationType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "vertical",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "kind": "LinkedField",
                            "name": "shipmentQuotes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isComplimentary",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCalculated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "totalAmount",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmounts",
                                    "kind": "LinkedField",
                                    "name": "convertedAmounts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "USD",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ShipmentServiceMethod",
                                "kind": "LinkedField",
                                "name": "serviceMethod",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Region",
                                    "kind": "LinkedField",
                                    "name": "region",
                                    "plural": false,
                                    "selections": [
                                      (v49/*: any*/),
                                      (v41/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v41/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v50/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemMeasurement",
                            "kind": "LinkedField",
                            "name": "measurement",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "addLabel",
                                    "value": true
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "fields",
                                    "value": [
                                      "height",
                                      "width",
                                      "depth",
                                      "diameter",
                                      "length"
                                    ]
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "separator",
                                    "value": " "
                                  }
                                ],
                                "concreteType": "ItemDisplayMeasurementType",
                                "kind": "LinkedField",
                                "name": "display",
                                "plural": true,
                                "selections": (v52/*: any*/),
                                "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ItemSize",
                                "kind": "LinkedField",
                                "name": "size",
                                "plural": false,
                                "selections": [
                                  (v51/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "unit",
                                    "value": "IN"
                                  }
                                ],
                                "concreteType": "ItemConvertedMeasurementsType",
                                "kind": "LinkedField",
                                "name": "convertedMeasurements",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/)
                                ],
                                "storageKey": "convertedMeasurements(unit:\"IN\")"
                              },
                              {
                                "alias": "widthDimensions",
                                "args": [
                                  (v53/*: any*/),
                                  {
                                    "kind": "Literal",
                                    "name": "fields",
                                    "value": [
                                      "width"
                                    ]
                                  }
                                ],
                                "concreteType": "ItemDisplayMeasurementType",
                                "kind": "LinkedField",
                                "name": "display",
                                "plural": true,
                                "selections": (v52/*: any*/),
                                "storageKey": "display(addLabel:false,fields:[\"width\"])"
                              },
                              {
                                "alias": "heightDimensions",
                                "args": [
                                  (v53/*: any*/),
                                  {
                                    "kind": "Literal",
                                    "name": "fields",
                                    "value": [
                                      "height"
                                    ]
                                  }
                                ],
                                "concreteType": "ItemDisplayMeasurementType",
                                "kind": "LinkedField",
                                "name": "display",
                                "plural": true,
                                "selections": (v52/*: any*/),
                                "storageKey": "display(addLabel:false,fields:[\"height\"])"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemClassification",
                            "kind": "LinkedField",
                            "name": "classification",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemCreator",
                            "kind": "LinkedField",
                            "name": "creators",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Creator",
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": (v55/*: any*/),
                                "storageKey": null
                              },
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "attribution",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v56/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isMultiSku",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isRingItem",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VariableAttribute",
                            "kind": "LinkedField",
                            "name": "variableAttributes",
                            "plural": true,
                            "selections": [
                              (v40/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VariableAttributeSortType",
                                "kind": "LinkedField",
                                "name": "variableAttributeData",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SwatchSort",
                                    "kind": "LinkedField",
                                    "name": "swatchSort",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Swatch",
                                        "kind": "LinkedField",
                                        "name": "swatch",
                                        "plural": false,
                                        "selections": [
                                          (v40/*: any*/),
                                          (v54/*: any*/),
                                          (v57/*: any*/),
                                          (v41/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              (v42/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "page",
                                "value": "searchAndBrowse"
                              },
                              (v43/*: any*/)
                            ],
                            "concreteType": "ItemDisplayPriceType",
                            "kind": "LinkedField",
                            "name": "displayPrice",
                            "plural": true,
                            "selections": [
                              (v46/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quantityDisplay",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "percentageOff",
                                "storageKey": null
                              },
                              (v48/*: any*/),
                              (v47/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showPriceLabel",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showPriceVariability",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "QuickViewDisplayType",
                            "kind": "LinkedField",
                            "name": "quickViewDisplay",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "QuickViewParagraph",
                                "kind": "LinkedField",
                                "name": "paragraphs",
                                "plural": true,
                                "selections": [
                                  (v58/*: any*/),
                                  (v38/*: any*/),
                                  {
                                    "alias": "mobileText",
                                    "args": (v59/*: any*/),
                                    "kind": "ScalarField",
                                    "name": "text",
                                    "storageKey": "text(formatType:\"MOBILE\")"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v60/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "QuickViewCategorySegments",
                                "kind": "LinkedField",
                                "name": "paragraphAttributeNames",
                                "plural": false,
                                "selections": [
                                  (v35/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "origin",
                                    "storageKey": null
                                  },
                                  (v61/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "periodPrefix",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v30/*: any*/),
                              {
                                "alias": "mobileTitle",
                                "args": (v59/*: any*/),
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": "title(formatType:\"MOBILE\")"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "carouselPhotos",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 2
                              }
                            ],
                            "concreteType": "ItemPhoto",
                            "kind": "LinkedField",
                            "name": "photos",
                            "plural": true,
                            "selections": [
                              (v62/*: any*/),
                              (v63/*: any*/),
                              (v64/*: any*/),
                              (v41/*: any*/),
                              (v65/*: any*/)
                            ],
                            "storageKey": "photos(limit:2)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "pdpMetaItems",
                            "kind": "LinkedField",
                            "name": "pdpMeta",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "topQuery",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isStorefrontOnly",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v66/*: any*/),
                            "concreteType": "viewInRoomPhotos",
                            "kind": "LinkedField",
                            "name": "viewInRoomPhotos",
                            "plural": true,
                            "selections": [
                              (v65/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "src",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "viewInRoomPhotosCenterPosition",
                                "kind": "LinkedField",
                                "name": "centerPosition",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "top",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "left",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "viewInRoomPhotosComparatorWidth",
                                "kind": "LinkedField",
                                "name": "comparatorWidth",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pixel",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "inches",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "viewInRoomPhotos(limit:1)"
                          },
                          {
                            "alias": "productPhotos",
                            "args": (v66/*: any*/),
                            "concreteType": "ItemPhoto",
                            "kind": "LinkedField",
                            "name": "photos",
                            "plural": true,
                            "selections": [
                              (v63/*: any*/),
                              (v64/*: any*/),
                              (v41/*: any*/)
                            ],
                            "storageKey": "photos(limit:1)"
                          },
                          (v41/*: any*/),
                          {
                            "condition": "showSeller",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Seller",
                                "kind": "LinkedField",
                                "name": "seller",
                                "plural": false,
                                "selections": [
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "relatedBuyPagesCount",
                    "variableName": "relatedBuyPagesCount"
                  }
                ],
                "concreteType": "RelatedCreatorBuyPages",
                "kind": "LinkedField",
                "name": "relatedCreatorBuyPages",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RelatedCreatorBuyPage",
                    "kind": "LinkedField",
                    "name": "relatedCreatorBuyPage",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinkData",
                        "kind": "LinkedField",
                        "name": "creatorBuyPageLinkData",
                        "plural": false,
                        "selections": (v39/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "creatorBuyPageFirstItem",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v66/*: any*/),
                            "concreteType": "ItemPhoto",
                            "kind": "LinkedField",
                            "name": "photos",
                            "plural": true,
                            "selections": [
                              (v63/*: any*/),
                              (v41/*: any*/)
                            ],
                            "storageKey": "photos(limit:1)"
                          },
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v29/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "disableForceFacet",
                "variableName": "disableForceFacet"
              },
              {
                "kind": "Variable",
                "name": "disableNonParameterizedUrlRedirects",
                "variableName": "disableNonParameterizedUrlRedirects"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "guestId",
                "variableName": "guestId"
              },
              {
                "kind": "Variable",
                "name": "localeOrigin",
                "variableName": "localeOrigin"
              },
              {
                "kind": "Variable",
                "name": "originalUrl",
                "variableName": "originalUrl"
              },
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page"
              },
              (v43/*: any*/),
              {
                "kind": "Variable",
                "name": "regions",
                "variableName": "regions"
              },
              {
                "kind": "Variable",
                "name": "regionsList",
                "variableName": "regionsList"
              },
              (v27/*: any*/),
              (v44/*: any*/),
              {
                "kind": "Variable",
                "name": "userId",
                "variableName": "personalizationId"
              }
            ],
            "concreteType": "ItemSearchQueryConnection",
            "kind": "LinkedField",
            "name": "itemSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MetaData",
                "kind": "LinkedField",
                "name": "meta",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prev",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "disableIndexing",
                    "storageKey": null
                  },
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "topQueries",
                    "storageKey": null
                  },
                  (v68/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canonical",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "next",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LanguageAnnotations",
                    "kind": "LinkedField",
                    "name": "languageAnnotations",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "href",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hrefLang",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "microdata",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "header",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subHeader",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "attributeDisplayName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemSearchQueryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchResult",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "item",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v66/*: any*/),
                            "concreteType": "ItemPhoto",
                            "kind": "LinkedField",
                            "name": "photos",
                            "plural": true,
                            "selections": [
                              (v64/*: any*/),
                              (v41/*: any*/)
                            ],
                            "storageKey": "photos(limit:1)"
                          },
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Seller",
                "kind": "LinkedField",
                "name": "seller",
                "plural": false,
                "selections": [
                  (v69/*: any*/),
                  (v41/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SearchBrowseParsedParam",
                "kind": "LinkedField",
                "name": "appliedFilters",
                "plural": true,
                "selections": [
                  (v70/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParamValue",
                    "kind": "LinkedField",
                    "name": "values",
                    "plural": true,
                    "selections": [
                      (v71/*: any*/),
                      (v72/*: any*/),
                      (v54/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LinkData",
                "kind": "LinkedField",
                "name": "breadcrumbs",
                "plural": true,
                "selections": [
                  (v38/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/)
                ],
                "storageKey": null
              },
              (v73/*: any*/),
              (v74/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SearchCorrectionsType",
                "kind": "LinkedField",
                "name": "searchCorrections",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "originalSearchTerm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "classificationSearchTerm",
                    "storageKey": null
                  },
                  (v73/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "semanticSearchTerm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "searchType",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "soldItems",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 28
                  }
                ],
                "concreteType": "soldResultsConnection",
                "kind": "LinkedField",
                "name": "soldResults",
                "plural": false,
                "selections": [
                  (v74/*: any*/)
                ],
                "storageKey": "soldResults(first:28)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "contentModuleId",
                    "variableName": "contentModuleId"
                  }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "browseContentModule",
                "plural": false,
                "selections": [
                  (v65/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrowseContentModuleBannerType",
                        "kind": "LinkedField",
                        "name": "banners",
                        "plural": true,
                        "selections": [
                          (v65/*: any*/),
                          (v30/*: any*/),
                          (v68/*: any*/),
                          (v75/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaCopy",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaStyle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textAlignment",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textColor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "backgroundColor",
                            "storageKey": null
                          },
                          (v76/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "format",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textPosition",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bannerImageWidth",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "termsLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrowseContentModuleTile",
                        "kind": "LinkedField",
                        "name": "tiles",
                        "plural": true,
                        "selections": [
                          (v57/*: any*/),
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "content",
                            "storageKey": null
                          },
                          (v56/*: any*/),
                          (v77/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ContentModuleBannerTiles",
                    "abstractKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v69/*: any*/),
                          (v67/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerPreferences",
                            "kind": "LinkedField",
                            "name": "sellerPreferences",
                            "plural": false,
                            "selections": (v78/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorefrontProfile",
                            "kind": "LinkedField",
                            "name": "liveStorefrontProfile",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                              },
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v68/*: any*/),
                      (v30/*: any*/),
                      (v79/*: any*/)
                    ],
                    "type": "ContentModuleRegular",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v79/*: any*/),
                      (v30/*: any*/),
                      (v80/*: any*/),
                      (v68/*: any*/),
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "linkText",
                        "storageKey": null
                      }
                    ],
                    "type": "ContentModuleBanner",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v68/*: any*/),
                      (v30/*: any*/),
                      (v76/*: any*/)
                    ],
                    "type": "ContentModuleIconicDesign",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bannerVideo",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bannerImage",
                        "storageKey": null
                      },
                      (v75/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "landingBackgroundTintColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "landingTilesBackgroundColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "landingTextColor",
                        "storageKey": null
                      },
                      (v30/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrowseContentModuleLandingTile",
                        "kind": "LinkedField",
                        "name": "landingTiles",
                        "plural": true,
                        "selections": [
                          (v30/*: any*/),
                          (v57/*: any*/),
                          (v56/*: any*/),
                          (v77/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ContentModuleLanding",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v42/*: any*/)
                ],
                "concreteType": "SearchBrowsePriceTile",
                "kind": "LinkedField",
                "name": "priceTiles",
                "plural": true,
                "selections": (v81/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RelatedSearch",
                "kind": "LinkedField",
                "name": "relatedSearches",
                "plural": true,
                "selections": [
                  (v82/*: any*/),
                  (v83/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayUriRef",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canFollowSearch",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 8
                  }
                ],
                "concreteType": "WordpressArticlesType",
                "kind": "LinkedField",
                "name": "editorialArticles",
                "plural": false,
                "selections": [
                  (v74/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WordpressArticleType",
                    "kind": "LinkedField",
                    "name": "articles",
                    "plural": true,
                    "selections": [
                      (v30/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WordpressArticleImageType",
                        "kind": "LinkedField",
                        "name": "imageUrl",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "full",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v80/*: any*/),
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "source",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "editorialArticles(first:8)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SearchBrowseFilter",
                "kind": "LinkedField",
                "name": "filters",
                "plural": true,
                "selections": [
                  (v70/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseFilterValue",
                    "kind": "LinkedField",
                    "name": "values",
                    "plural": true,
                    "selections": (v81/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LinkData",
                "kind": "LinkedField",
                "name": "popularSearchesLink",
                "plural": false,
                "selections": [
                  (v38/*: any*/),
                  (v36/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternalBuyLinkType",
                "kind": "LinkedField",
                "name": "relatedPages",
                "plural": true,
                "selections": [
                  (v83/*: any*/),
                  (v82/*: any*/),
                  (v41/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "relatedCreatorsConnection",
                "kind": "LinkedField",
                "name": "relatedCreators",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "relatedCreatorsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RelatedCreatorType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/),
                          (v56/*: any*/),
                          (v41/*: any*/),
                          {
                            "alias": "shopAllTitle",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": "creatorName",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "pageObjectName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v65/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v30/*: any*/),
                                  (v50/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v66/*: any*/),
                                    "concreteType": "ItemPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                      (v62/*: any*/),
                                      (v41/*: any*/)
                                    ],
                                    "storageKey": "photos(limit:1)"
                                  }
                                ],
                                "type": "Item",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v41/*: any*/)
                                ],
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "browseContent",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "browseContentModule",
                "plural": false,
                "selections": [
                  (v65/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v31/*: any*/),
                    "type": "ContentModuleRegular",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "topCategoryL1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "searchRequestId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemSearchSponsored",
                "kind": "LinkedField",
                "name": "sponsored",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxAvailable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchSponsoredMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "itemId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "impressionTrackerLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clickTrackerLink",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BottomModule",
                "kind": "LinkedField",
                "name": "bottomModule",
                "plural": true,
                "selections": [
                  (v30/*: any*/),
                  (v68/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "maxCreatorDesigns",
                    "value": 16
                  }
                ],
                "concreteType": "DesignPageInfo",
                "kind": "LinkedField",
                "name": "designPageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IconicDesign",
                    "kind": "LinkedField",
                    "name": "design",
                    "plural": false,
                    "selections": (v55/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Creator",
                    "kind": "LinkedField",
                    "name": "primaryCreator",
                    "plural": false,
                    "selections": (v55/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CreatorDesigns",
                    "kind": "LinkedField",
                    "name": "creatorDesigns",
                    "plural": true,
                    "selections": [
                      (v83/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinkData",
                        "kind": "LinkedField",
                        "name": "browsePageLinkData",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          (v36/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v54/*: any*/),
                      (v57/*: any*/),
                      {
                        "alias": null,
                        "args": (v28/*: any*/),
                        "concreteType": "QuickViewDisplayType",
                        "kind": "LinkedField",
                        "name": "quickViewDisplay",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/),
                          (v56/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "QuickViewParagraph",
                            "kind": "LinkedField",
                            "name": "paragraphs",
                            "plural": true,
                            "selections": [
                              (v58/*: any*/),
                              (v38/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "QuickViewCategorySegments",
                            "kind": "LinkedField",
                            "name": "paragraphAttributeNames",
                            "plural": false,
                            "selections": [
                              (v61/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "material",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "averagePrice",
                                "plural": false,
                                "selections": [
                                  (v46/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numAvailable",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v60/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "designPageInfo(maxCreatorDesigns:16)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "faqHeader",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "QuestionType",
                "kind": "LinkedField",
                "name": "questionsAnswers",
                "plural": true,
                "selections": [
                  (v41/*: any*/),
                  (v83/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answerCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnswerType",
                    "kind": "LinkedField",
                    "name": "answers",
                    "plural": true,
                    "selections": [
                      (v40/*: any*/),
                      (v38/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedCreatedDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerPreferences",
                            "kind": "LinkedField",
                            "name": "sellerPreferences",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "label",
                                "storageKey": null
                              },
                              (v71/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "scrollLogo",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vanityUriRef",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appliedPersonalizationList",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SortType",
                "kind": "LinkedField",
                "name": "sort",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseSortCurrentOption",
                    "kind": "LinkedField",
                    "name": "currentOption",
                    "plural": false,
                    "selections": (v78/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SearchBrowseCategoryTiles",
                "kind": "LinkedField",
                "name": "categoryTiles",
                "plural": true,
                "selections": [
                  (v65/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AbTestConfigV2UserVariant",
                "kind": "LinkedField",
                "name": "seoAbTestV2List",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "variant",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbTestConfigV2",
                    "kind": "LinkedField",
                    "name": "config",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "testName",
                        "storageKey": null
                      },
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "trackedAbTests",
                "storageKey": null
              },
              (v41/*: any*/)
            ],
            "storageKey": null
          },
          (v41/*: any*/),
          {
            "condition": "fetchRegionalInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "regionsInfo",
                "args": (v84/*: any*/),
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": (v85/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v84/*: any*/),
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": (v85/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isTrade",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "address",
                    "value": {
                      "country": "us"
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "regionBoundaryTypes",
                    "value": [
                      "METROPOLITAN",
                      "DISTRICT",
                      "DOMESTIC"
                    ]
                  },
                  {
                    "kind": "Literal",
                    "name": "regionType",
                    "value": "ITEM_LOCATION"
                  }
                ],
                "concreteType": "Region",
                "kind": "LinkedField",
                "name": "regions",
                "plural": true,
                "selections": [
                  (v49/*: any*/),
                  (v71/*: any*/),
                  (v41/*: any*/)
                ],
                "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")"
              }
            ]
          },
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "guestId",
                    "variableName": "rerankGuestId"
                  },
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "rerankUserId"
                  }
                ],
                "kind": "ScalarField",
                "name": "isEligibleForRerank",
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId"
                  }
                ],
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v40/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVerifiedTrade",
                    "storageKey": null
                  },
                  (v65/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "kind": "LinkedField",
                    "name": "tradeFirm",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "rewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ParentProgram",
                            "kind": "LinkedField",
                            "name": "currentProgram",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LoyaltyProgram",
                                "kind": "LinkedField",
                                "name": "programInfo",
                                "plural": false,
                                "selections": [
                                  (v72/*: any*/),
                                  (v41/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v86/*: any*/),
                        "concreteType": "favoritesConnection",
                        "kind": "LinkedField",
                        "name": "favorites",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "favoritesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Favorite",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v40/*: any*/),
                                  (v54/*: any*/),
                                  (v41/*: any*/),
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__id",
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  (v65/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v86/*: any*/),
                        "filters": [],
                        "handle": "connection",
                        "key": "SharedSaveSearchContext_favorites",
                        "kind": "LinkedHandle",
                        "name": "favorites"
                      }
                    ]
                  },
                  (v41/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/545.0.0-2026-02-05T14:54:35.766Z/sbRespCreatorsRootQuery",
    "metadata": {},
    "name": "sbRespCreatorsRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ead2dc058da889ca5741cfbe57de40d5";

export default node;
